/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Template_InvalidInputs */

const en_error_template_invalid = /** @type {(inputs: Error_Template_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The template cannot be saved as it is: correct the fields marked.`)
};

/**
* | output |
* | --- |
* | "The template cannot be saved as it is: correct the fields marked." |
*
* @param {Error_Template_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_template_invalid = /** @type {((inputs?: Error_Template_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Template_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_template_invalid(inputs)
});